/** Serialize a JSON-LD blob into a `<script type="application/ld+json">` tag.
 *
 *  Lives in a `.ts` file (not inside `+layout.svelte`) so Svelte 5's parser
 *  never sees the literal `<${...}` template — it would otherwise interpret
 *  it as the dynamic-component-tag syntax (`<{Foo}>`) and fail to parse.
 *
 *  Defense in depth: replace `<` with `\\u003c` inside the JSON payload so a
 *  stray `</script>` in any string field can't break out of the script
 *  context. Standard JSON.stringify does not escape `<` by default. */
export function jsonLdScriptTag(ld: Record<string, unknown>): string {
  const json = JSON.stringify(ld).replace(/</g, '\\u003c');
  return `<${'script'} type="application/ld+json">${json}<${'/script'}>`;
}
